import { useSelector } from 'react-redux';
import { getMyProfile } from '@/entities/Profile';
import { getCurrentDay } from '@/shared/lib/utils/getCurrentDay';

export const HomeGreeting = () => {
  const user = useSelector(getMyProfile);
  const currentDate = getCurrentDay();

  return (
    <div>
      <h2 className="text-[40px] font-medium">Welcome, {user?.username || ''} 👋</h2>
      <p className="font-medium mt-2">
        Today: <span className="text-grey-secondary font-normal">{currentDate}</span>
      </p>
    </div>
  );
};
